import { useState } from 'react';
import debounce from 'react-utils/debounce';
import { validateLink } from '../utils/link';
export const useLinkValidation = ({
  linkType,
  href,
  isValidLink,
  onLinkTypeChange,
  onUpdate,
  onSubmit
}) => {
  const [hasSubmitted, setHasSubmitted] = useState(false);
  const debouncedLinkValidationUpdate = debounce((validatedLinkType, link) => {
    onUpdate({
      isValidLink: validateLink(validatedLinkType, link)
    });
  }, 300);
  const handleLinkTypeChange = value => {
    setHasSubmitted(false);
    onLinkTypeChange(value);
  };
  const handleUpdate = linkInfo => {
    if (linkInfo.href && hasSubmitted) {
      debouncedLinkValidationUpdate(linkType, linkInfo.href);
    }
    onUpdate(linkInfo);
  };
  const handleSubmit = linkInfo => {
    let newIsValidLink = isValidLink;
    if (!hasSubmitted) {
      newIsValidLink = validateLink(linkType, href);
    }
    if (hasSubmitted || newIsValidLink) {
      onSubmit(linkInfo);
      return true;
    } else {
      onUpdate({
        isValidLink: newIsValidLink
      });
      setHasSubmitted(true);
      return false;
    }
  };
  return [handleLinkTypeChange, handleUpdate, handleSubmit];
};